(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bm-collection-banner"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* mobile: make sure the current stage pill is visible in the sideways row */
  function run() {
    document.querySelectorAll('.bm-cb__pills').forEach(function (row) {
      var cur = row.querySelector('.is-current');
      if (!cur || row.scrollWidth <= row.clientWidth) return;
      var li = cur.parentElement;
      row.scrollLeft = Math.max(0, li.offsetLeft - (row.clientWidth - li.offsetWidth) / 2);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bm-footer"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* after a signup the page reloads: bring the message into view */
  if (window.location.search.indexOf('customer_posted=true') > -1 || window.location.hash === '#BmFooterSignup') {
    var el = document.getElementById('bm-footer-signup');
    if (el) setTimeout(function () { el.scrollIntoView({ block: 'center' }); }, 100);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bm-pdp-main"]) return;
  try {
    
(function () {
  function addBusinessDays(n) {
    var d = new Date(), added = 0;
    while (added < n) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) added++; }
    return d.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' });
  }

  function init(root) {
    if (!root || root.dataset.bmInit) return;
    root.dataset.bmInit = '1';

    /* delivery date: always a real date */
    root.querySelectorAll('[data-bm-date]').forEach(function (el) {
      el.textContent = addBusinessDays(parseInt(el.dataset.days, 10) || 4);
    });

    /* gallery */
    var track = root.querySelector('[data-bm-slides]');
    var thumbs = root.querySelectorAll('.bm-pdp__thumb');
    var dots = root.querySelectorAll('.bm-pdp__dot');
    function mark(i) {
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
    }
    if (track) {
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var i = parseInt(t.dataset.index, 10) || 0;
          track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
          mark(i);
        });
      });
      var st;
      track.addEventListener('scroll', function () {
        clearTimeout(st);
        st = setTimeout(function () { mark(Math.round(track.scrollLeft / track.clientWidth)); }, 60);
      }, { passive: true });
    }

    /* options */
    var opts = root.querySelectorAll('.bm-pdp__opt');
    var atc = root.querySelector('[data-bm-atc]');
    var stickyName = root.querySelector('[data-bm-sticky-name]');
    var stickyPrice = root.querySelector('[data-bm-sticky-price]');
    var current = opts[0];
    /* an option whose variant can't be bought (e.g. sold out) is disabled; start on the first one that can be bought */
    var buyable = Array.prototype.filter.call(opts, function (o) { return !o.disabled; });
    function select(opt) {
      current = opt;
      opts.forEach(function (o) {
        var on = o === opt;
        o.classList.toggle('is-selected', on);
        o.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      if (atc && !atc.disabled) atc.textContent = opt.dataset.button;
      if (stickyName) stickyName.textContent = opt.dataset.label;
      if (stickyPrice) stickyPrice.textContent = opt.dataset.price;
    }
    opts.forEach(function (o) { o.addEventListener('click', function () { if (!o.disabled) select(o); }); });
    if (buyable.length) {
      select(current && !current.disabled ? current : buyable[0]);
    } else {
      current = null;
      [atc, root.querySelector('[data-bm-sticky-atc]')].forEach(function (b) {
        if (b) { b.disabled = true; b.textContent = root.dataset.soldout || 'Sold out'; }
      });
    }

    /* add to cart */
    var err = root.querySelector('[data-bm-error]');
    function add(btn) {
      if (!current) return;
      var label = btn.textContent;
      btn.disabled = true;
      btn.textContent = root.dataset.adding || 'Adding…';
      if (err) err.hidden = true;
      /* Cart drawer (Theme settings > Cart type: Drawer): add, then open Dawn's drawer like the theme's own product form.
         "checkout" in this section's setting still goes straight to checkout; no drawer on the page = cart page. */
      var toCheckout = root.dataset.afterAdd === 'checkout';
      var drawer = toCheckout ? null : document.querySelector('cart-drawer');
      var useDrawer = !!(drawer && typeof drawer.renderContents === 'function' && typeof drawer.getSectionsToRender === 'function');
      var payload = { items: [{ id: Number(current.dataset.variant), quantity: 1 }] };
      if (useDrawer) {
        payload.sections = drawer.getSectionsToRender().map(function (x) { return x.id; });
        payload.sections_url = window.location.pathname;
        if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(btn);
      }
      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function (res) {
          if (useDrawer && res && res.sections) {
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bm-pdp', productVariantId: payload.items[0].id, cartData: res });
            }
            /* renderContents expects the added item's id, like Dawn's product form response */
            if (res.items && res.items[0] && res.id == null) res.id = res.items[0].id;
            drawer.renderContents(res);
            drawer.classList.remove('is-empty');
            btn.disabled = false;
            btn.textContent = label;
            return;
          }
          window.location.href = toCheckout ? '/checkout' : '/cart';
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = label;
          if (err) err.hidden = false;
        });
    }
    if (atc) atc.addEventListener('click', function () { add(atc); });
    var stickyBtn = root.querySelector('[data-bm-sticky-atc]');
    if (stickyBtn) stickyBtn.addEventListener('click', function () { add(stickyBtn); });
    window.addEventListener('pageshow', function () {
      if (current) [atc, stickyBtn].forEach(function (b) { if (b) b.disabled = false; });
      if (current) select(current);
      if (stickyBtn) stickyBtn.textContent = stickyBtn.dataset.label || stickyBtn.textContent;
    });
    if (stickyBtn) stickyBtn.dataset.label = stickyBtn.textContent;

    /* mobile sticky bar: shows once the main button has scrolled off the top */
    var bar = root.querySelector('[data-bm-sticky]');
    if (bar && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      }).observe(atc);
    }

    /* mini FAQ: first open, click to open/close */
    root.querySelectorAll('.bm-pdp__faq-q').forEach(function (q) {
      q.addEventListener('click', function () {
        var item = q.parentNode, open = !item.classList.contains('is-open');
        item.classList.toggle('is-open', open);
        q.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  function all() { document.querySelectorAll('[data-bm-pdp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('[data-bm-pdp]')); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bm-real-results"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.bmInit) return;
    root.dataset.bmInit = '1';
    var track = root.querySelector('.bm-rr__track');
    if (!track) return;
    var cards = Array.prototype.slice.call(track.children);
    var dots = Array.prototype.slice.call(root.querySelectorAll('.bm-rr__dot'));
    var prev = root.querySelector('.bm-rr__arrow--prev');
    var next = root.querySelector('.bm-rr__arrow--next');

    function step() {
      if (!cards[0]) return track.clientWidth;
      return cards[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0);
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var scrolls = max > 2;
      if (prev) { prev.hidden = !scrolls; prev.disabled = track.scrollLeft <= 2; }
      if (next) { next.hidden = !scrolls; next.disabled = track.scrollLeft >= max - 2; }
      var i = Math.round(track.scrollLeft / step());
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
    }
    var t;
    track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(update, 60); }, { passive: true });
    window.addEventListener('resize', update);
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { track.scrollTo({ left: i * step(), behavior: 'smooth' }); });
    });
    update();
  }
  function all() { document.querySelectorAll('.bm-rr').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('.bm-rr')); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bm-shop-by-stage"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.bmInit) return;
    root.dataset.bmInit = '1';
    var track = root.querySelector('.bm-stage__track');
    var dots = Array.prototype.slice.call(root.querySelectorAll('.bm-stage__dot'));
    if (!track || !dots.length) return;
    var cards = Array.prototype.slice.call(track.children);
    function pad() { return parseFloat(getComputedStyle(track).paddingLeft) || 0; }

    function active() {
      var left = track.scrollLeft, best = 0, bestDist = Infinity;
      cards.forEach(function (c, i) {
        var d = Math.abs((c.offsetLeft - track.offsetLeft - pad()) - left);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === best); });
    }
    var t;
    track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(active, 60); }, { passive: true });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        if (!cards[i]) return;
        track.scrollTo({ left: cards[i].offsetLeft - track.offsetLeft - pad(), behavior: 'smooth' });
      });
    });
  }
  function all() { document.querySelectorAll('.bm-stage').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('.bm-stage')); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bm-side-effect-tabs"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.bmTabs) return;
    root.dataset.bmTabs = '1';
    var list = root.querySelector('[role="tablist"]');
    if (!list) return;
    var tabs = Array.prototype.slice.call(list.querySelectorAll('[role="tab"]'));
    var panels = tabs.map(function (t) { return document.getElementById(t.getAttribute('aria-controls')); });

    function select(i, focus) {
      tabs.forEach(function (t, j) {
        var on = i === j;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (panels[j]) panels[j].hidden = !on;
      });
      if (focus) tabs[i].focus({ preventScroll: true });
      /* keep the selected pill visible in the sideways-scrolling row (mobile/tablet) */
      if (list.scrollWidth > list.clientWidth) {
        var t = tabs[i];
        var target = t.offsetLeft - (list.clientWidth - t.offsetWidth) / 2;
        list.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
      }
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(i, false); });
      tab.addEventListener('keydown', function (e) {
        var n = tabs.length, k = e.key, next = null;
        if (k === 'ArrowRight' || k === 'ArrowDown') next = (i + 1) % n;
        else if (k === 'ArrowLeft' || k === 'ArrowUp') next = (i - 1 + n) % n;
        else if (k === 'Home') next = 0;
        else if (k === 'End') next = n - 1;
        if (next === null) return;
        e.preventDefault();
        select(next, true);
      });
    });
  }
  function all() { document.querySelectorAll('.bm-tabs').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('.bm-tabs')); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
